<template>
  <div>
    <div>В рамках нахождения в лимитах карты заменены на {{data.owner && data.owner.short_name}}. Сбербанк</div>
    <div>{{data.type === 1 ? 'VISA' : 'MASTER'}} - {{data.number}}</div>
    <div>{{data.owner && data.owner.full_name}}</div>
    <div>Автописьма изменены, СМС информирование подключено на платформу</div>
    <div>Доступ в Сбербанк онлайн:<br>
      логин - {{data.owner && data.owner.banking_login}}<br>
      пароль - {{data.owner && data.owner.banking_password}}
    </div>
    <div>Прошлые карты&nbsp;открыты, старые платежи МОГУТ прийти туда, поэтому старым клиентам рассылать информацию об изменении реквизитов НЕ нужно.</div>
    <div>Ротация карт будет происходить раз в 10 дней.</div>
  </div>
</template>

<script>

  export default {
    props: ['data'],
  }

</script>
